import {
  validateCreditCardExpireMonth,
  validateCreditCardExpireYear,
  validateCreditCardHolderName,
  validateCreditCardNumber,
  validateCreditCardSecurityCode,
  validateCreditCardType,
  validateFutureExpireDate,
  validateMobileCarrier,
  validateMyCreditCardSecurityCode,
  validatePaymentInputMethod,
  validatePaymentInputTerm,
} from './PaymentInputInfoValidation'
import {ContractMethod, ContractTerm, CreditCardType} from '../../Props/ContractInputInfo'
import {Optional} from '../../../Common/TypeHelper'

export type ValidationContractInput = {
  paymentInputTerm: ContractTerm
  paymentInputMethod: Optional<ContractMethod>
  creditCardType: CreditCardType
  creditCardNumber: string
  creditCardExpireMonth: string
  creditCardExpireYear: string
  creditCardHolderName: string
  creditCardSecurityCode: string
  myCreditCardSecurityCode: string
  convenienceStore: string
  mobileCarrier: string
  nextContractStartDate: string
}

type CombinationResult = {
  creditCardFutureExpireDate: string[]
}

export type ValidationContractResultDetail = {
  [K in keyof Omit<ValidationContractInput, 'nextContractStartDate'>]: string[]
} & CombinationResult

export type ValidationContractResult = {
  hasError: boolean
  errors: Omit<ValidationContractResultDetail, 'nextContractStartDate'>
}

export const validateMemberContractInput = (
  input: ValidationContractInput,
): ValidationContractResult => {

  const details: ValidationContractResultDetail = {
    paymentInputTerm: validatePaymentInputTerm(input.paymentInputTerm, true),
    paymentInputMethod:
      validatePaymentInputMethod(input.paymentInputMethod, true),
    creditCardType: validateCreditCardType(input.paymentInputMethod, input.creditCardType),
    creditCardNumber: validateCreditCardNumber(
      input.paymentInputMethod, input.creditCardType, input.creditCardNumber),
    creditCardExpireMonth: validateCreditCardExpireMonth(
      input.paymentInputMethod, input.creditCardType, input.creditCardExpireMonth),
    creditCardExpireYear: validateCreditCardExpireYear(
      input.paymentInputMethod, input.creditCardType, input.creditCardExpireYear),
    creditCardFutureExpireDate: validateFutureExpireDate(
      input.paymentInputMethod,
      input.creditCardType,
      input.creditCardExpireMonth,
      input.creditCardExpireYear,
      input.nextContractStartDate,
    ),
    creditCardHolderName: validateCreditCardHolderName(
      input.paymentInputMethod, input.creditCardType, input.creditCardHolderName),
    creditCardSecurityCode: validateCreditCardSecurityCode(
      input.paymentInputMethod, input.creditCardType, input.creditCardSecurityCode),
    myCreditCardSecurityCode: validateMyCreditCardSecurityCode(
      input.paymentInputMethod, input.creditCardType, input.myCreditCardSecurityCode),
    convenienceStore: [],
    mobileCarrier: validateMobileCarrier(input.paymentInputMethod, input.mobileCarrier),
  }

  const hasError =
    Object.values(details)
      .map(errorArray => errorArray.length)
      .some(length => length > 0)

  return {
    hasError: hasError,
    errors: details,
  }
}
